import { Divider, Stack } from '@mui/material';
import {
  HeroMetric,
  HeroMetricProps,
} from '@features/campaigns/components/Summary/HeroMetric';
import { ChartTitle } from './ChartTitle';

type MetricType = Pick<HeroMetricProps, 'value' | 'confidenceLevel'> & {
  category: string;
};

type HeroBreakdownProps = Omit<
  HeroMetricProps,
  'value' | 'confidenceLevel' | 'label'
> & {
  title: string;
  overallMetric: MetricType;
  subMetrics: MetricType[];
};

export const HeroBreakdown = (props: HeroBreakdownProps) => {
  return (
    <Stack direction="column" gap="1rem" height="100%">
      <ChartTitle title={props.title} />
      <Stack
        gap="1rem"
        height="100%"
        justifyContent="center"
        alignItems="center"
      >
        <HeroMetric
          {...props}
          label={props.overallMetric.category}
          value={props.overallMetric.value}
          confidenceLevel={props.overallMetric.confidenceLevel}
        />
        <Divider sx={{ width: '100%' }} />

        <Stack direction="column" gap="1rem">
          {props.subMetrics.map(subMetric => (
            <HeroMetric
              {...props}
              key={subMetric.category}
              size="sm"
              value={subMetric.value}
              confidenceLevel={subMetric.confidenceLevel}
              label={subMetric.category}
              icon={undefined}
            />
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
};
